import { ReactElement, ReactNode } from 'react';
import { SxProps, Theme, styled } from '@mui/material';

const StyledLi = styled('li')(({ theme }) => ({
    marginBottom: theme.spacing(1.5),

    [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(0.5),
    },
}));

type FooterColumnItemProps = {
    sx?: SxProps<Theme>;
    children?: ReactNode;
};

export const FooterColumnItem = (props: FooterColumnItemProps): ReactElement => <StyledLi {...props} />;
